import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from "lodash";
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core/styles';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputBase from '@material-ui/core/InputBase';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { Button } from '@material-ui/core';
import Dialog from "material-ui/Dialog";
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { authHeader, history } from '../../helpers';
import api from '../../constants/api';
import BreadCrumbNav from '../BreadCrumbNav'
import './TerminalNew.css';
import { getUser, checkError } from '../../helpers';
import swal from 'sweetalert';
import { postApi } from '../../helpers/http';

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid rgb(118, 118, 118)',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class TerminalNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      limit: 1000,
      startDate: "",
      tmp_user_id: -1,
      user_id: -1,
      os_id: -1,
      pc_name: "",
      manufacturer: "",
      system_model: "",
      serial_number: "",
      openAlert: false,
      editSuccess: false,
      confirmDialog: false,
      user_name: ""
    };
  }

  componentDidMount() {
    const { getTerminals, getSettings, getOsSettings, getManufacturers, getModels } = this.props
    const params = {
      offset: this.state.offset * this.state.limit,
      limit: this.state.limit
    };
    getTerminals(params);

    const paramsUserMaster = {
      offset: 0,
      limit: this.state.limit,
      table_name: "user_master"
    };
    getSettings(paramsUserMaster);

    const osparams = {
      offset: this.state.offset * this.state.limit,
      limit: this.state.limit
    };
    getOsSettings(osparams);

    // 製造元取得
    getManufacturers({});

    // モデル取得
    getModels({});
  }

  render() {
    const user = getUser();
    const { usersMaster, ositems, manufacturers, models } = this.props;
    // console.log(usersMaster.detailData);
    const sortedUsers = [...(usersMaster.detailData || [])].sort((a, b) =>
      (a.name || "").localeCompare(b.name || "", undefined, {
        sensitivity: "base",
        numeric: true
      })
    );

    const changeUserMaster = (event) => {
      const {id, name} = event.target;
      this.setState({tmp_user_id: id, user_id: id, user_name: name});
    };

    const changeTemminalOs = (event) => {
      const   value = Number(event.target.value);
      this.setState({ os_id: isNaN(value) ? -1 : value });
    };

    
    const changeManufacturer = (event, value) => {
      // const {value} = event.target;
      this.setState({
        manufacturer: value ? value : ''
      });
    };

    const changePcName = (event) => {
      const {value} = event.target;
      this.setState({
        pc_name: value
      });
    };

    const changeSystemModel = (event, value) => {
      // const {value} = event.target;
      this.setState({
        system_model: value ? value : ''
      });
    };

    const changeSerialNumber = (event) => {
      const {value} = event.target;
      this.setState({
        serial_number: value
      });
    };

    function genMAC(){
      var hexDigits = "0123456789ABCDEF";
      var macAddress = "";
      for (var i = 0; i < 6; i++) {
          macAddress+=hexDigits.charAt(Math.round(Math.random() * 15));
          macAddress+=hexDigits.charAt(Math.round(Math.random() * 15));
          if (i !== 5) macAddress += ":";
      }
  
      return "M:" + macAddress;
    }

    const handleCheckInputData = (user_id, pc_name, manufacturer, system_model,serial_number,os_id ) => {
      if (pc_name === "") {
        swal({
            title: "設定エラー！",
            text: "端末名を設定してください。",
            icon: "warning",
            buttons: "はい"
        });
        return false;
      }
      if (manufacturer === "") {
        swal({
            title: "設定エラー！",
            text: "製造元を設定してください。",
            icon: "warning",
            buttons: "はい"
        });
        return false;
      }
      if (system_model === "") {
        swal({
            title: "設定エラー！",
            text: "モデルを設定してください。",
            icon: "warning",
            buttons: "はい"
        });
        return false;
      }
      if (serial_number === "") {
        swal({
            title: "設定エラー！",
            text: "シリアルを設定してください。",
            icon: "warning",
            buttons: "はい"
        });
        return false;
      }
      return true;
    }

    const handleSaveTerminal = async () => {
      const { user_id, pc_name, manufacturer, system_model, serial_number, os_id } = this.state;

      if (!handleCheckInputData(user_id, pc_name, manufacturer, system_model, serial_number, os_id)) {
        return;
      }

      const data = {
        "process_type": "insertTerminal",
        "used_start_time": this.state.startDate !== "" ? new Date(this.state.startDate).toISOString().replace('T', ' ').slice(0, 19) : "",
        "user_id": Number(this.state.user_id),
        "os_id": Number(this.state.os_id),   
        "pc_name": this.state.pc_name.trim(),
        "manufacturer": this.state.manufacturer.trim(),
        "system_model": this.state.system_model.trim(),
        "serial_number": this.state.serial_number.trim(),
        "mac_add": genMAC()
      };

      try {
        const json = await postApi(data);
        if (json.statusCode == 200) {
          if (manufacturers.indexOf(data.manufacturer) === -1) {
            manufacturers.push(data.manufacturer);
          }
          if (models.indexOf(data.system_model) === -1) {
            models.push(data.system_model);
          }
          // console.log(json);
          this.setState({
            startDate: "",
            user_id: -1,
            os_id: -1,
            pc_name: "",
            manufacturer: "",
            system_model: "",
            serial_number: "",
            mac_add: ""
          });
          swal({
            title: "登録しました。",
            icon: "success",
            button: "はい",
          });
        } else {
          swal({
            title: "設定エラー！",
            text: json.data || "登録に失敗しました。",
            icon: "warning",
            button: "はい",
          });
        };
      } catch (error) {
        console.error('Error:', error);
        swal({
          title: "エラー！",
          text: "予期しないエラーが発生しました。",
          icon: "error",
          button: "はい",
        });
      };

    };

    const handleEdit = async (event) => {
      const { user_id, pc_name, manufacturer, system_model, serial_number, os_id } = this.state;
      if (!handleCheckInputData(user_id, pc_name, manufacturer, system_model, serial_number, os_id)) {
        return;
      }

      swal({
        title: "登録しますか？",
        icon: "warning",
        buttons: ["いいえ", "はい"],
        dangerMode: true,
      })

      .then(async (confirm) => {
        if (!confirm) return;
        const data = {
          "process_type": "getTerminal",
          "used_start_time": this.state.startDate !== "" ? new Date(this.state.startDate).toISOString().replace('T', ' ').slice(0, 19) : "",

          "user_id": Number(this.state.user_id),
          "os_id": Number(this.state.os_id),   
          "pc_name": this.state.pc_name,
          "manufacturer": this.state.manufacturer,
          "system_model": this.state.system_model,
          "serial_number": this.state.serial_number,
          "mac_add": genMAC()
        };

        try {
          const json = await postApi(data);
          const editSuccess = checkError(json) === false;
          if (json.statusCode == 200) {
            if (json.data && json.data.detailData && json.data.detailData.length > 0) {
              swal({
                title: "上書き確認",
                text: `${this.state.manufacturer}／${this.state.serial_number}の端末は既に存在します。\n上書きしますか？`,
                icon: "warning",
                buttons: ["いいえ", "はい"],
                dangerMode: true,
              })
              .then((confirmOverwrite) => {
                if (confirmOverwrite) {
                  handleSaveTerminal(); 
                }
              });
            } else {
              handleSaveTerminal();
            }
          } else {
            swal({
              title: "設定エラー！",
              text: json.data || "登録に失敗しました。",
              icon: "warning",
              button: "はい",
            });
          };
        } catch {
          swal({
            title: "設定エラー！",
            text: "登録に失敗しました。",
            icon: "warning",
            button: "はい",
          });
        };

      });
    };

    const handleCloseConfirmDialog = () => {
      this.setState({confirmDialog: false});
    };

    const handleCloseSuccess = () => {
      this.setState({openAlert: false,});
    };

    const handleChangePage = (event) => {
      if (event.target.value === "edit") {
        history.push('/index.html?p=terminal-edit');
      }
    };

    const handleOnBlur = (event) => {

      if (this.state.tmp_user_id == -1) {
        this.setState({
          user_id: "",
          user_name: ""
        });
      };


    };

    const changeStartDate = (event) => {
      const {value} = event.target;
      this.setState({
        startDate: value
      });
    };

    return (
      <div className="content-container">
        <BreadCrumbNav screenName="登録端末編集"></BreadCrumbNav>
        <div className="loginname">ログイン名：{user.username}</div>
        <h1 className="terminalnew__heading">登録端末編集</h1>
       
        <div className="terminalnew-form__switch-group">
          <div className="terminalnew-form__group-border">
            <RadioGroup aria-label="terminalnew" name="terminalnew" value={"new"} onChange={handleChangePage}>
              <FormControlLabel value="edit" control={<Radio style={{height: 24}} color="primary"/>} label="現在端末に使用者紐付け・変更" />
              <FormControlLabel value="new" control={<Radio style={{height: 24}} color="primary"/>} label="新規登録" />
            </RadioGroup>
          </div>
        </div>
        
        <div className="terminalnew-form">
          <div className="terminalnew-form__group-item">
            <div className="terminalnew-form__item-title"><span>名前</span></div>
            <Autocomplete
              freeSolo
              className="terminalnew-form__item-value"
              // options={usersMaster.detailData || []}
              options={sortedUsers || []}
              getOptionLabel={(option) => 
                typeof option === "string" ? option : option?.name || ""
              }
              value={
                usersMaster.detailData?.find(
                  u => u.i_num === this.state.user_id
                ) || null
              }
              inputValue={this.state.user_name}
              onChange={(event, newValue) => {
                changeUserMaster({
                  target: {
                    id: newValue ? newValue.i_num : -1,
                    name: newValue ? newValue.name : ""
                  }
                });
              }}
              onInputChange={(event, newInputValue) => {
                  this.setState({
                      tmp_user_id: -1,
                      user_name: newInputValue
                  });
              }}
              // isOptionEqualToValue={(option, value) => option.i_num === value.i_num}
              clearOnEscape
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="autocomplete-filter"
                  variant="outlined"
                  onBlur={handleOnBlur}
                />
              )}
            />
          </div>

          <div className="terminalnew-form__group-item">
            <div className="terminalnew-form__item-title"><span>部</span></div>
            <NativeSelect className="terminaledit-form__item-value"
              id="demo-customized-select-native"
              value={this.state.user_id}
              input={<BootstrapInput />}
              disabled={true}
            >
              <option aria-label="無し" value="" />
              {usersMaster.detailData && (usersMaster.detailData).map((userMaster, index) => (
                <option value={userMaster.i_num} key={index}>{userMaster.section_name}</option>
              ))}
            </NativeSelect>
          </div>

          <div className="terminalnew-form__group-item">
            <div className="terminalnew-form__item-title"><span>課</span></div>
            <NativeSelect className="terminaledit-form__item-value"
              id="demo-customized-select-native"
              value={this.state.user_id}
              input={<BootstrapInput />}
              disabled={true}
            >
              <option aria-label="無し" value="" />
              {usersMaster.detailData && (usersMaster.detailData).map((userMaster, index) => (
                <option value={userMaster.i_num} key={index}>{userMaster.department_name}</option>
              ))}
            </NativeSelect>
          </div>

          <div className="terminalnew-form__group-item">
            <div className="terminalnew-form__item-title"><span>端末名</span></div>
            <TextField variant="outlined" className="terminalnew-form__item-value"
                value={this.state.pc_name} 
                onChange={changePcName}/>
          </div>

          {/* <div className="terminalnew-form__group-item">
            <div className="terminalnew-form__item-title"><span>製造元</span></div>
            <TextField variant="outlined" className="terminalnew-form__item-value"
                value={this.state.manufacturer} 
                onChange={changeManufacturer}/>
          </div> */}

          <div className="terminalnew-form__group-item">
            <div className="terminalnew-form__item-title"><span>製造元</span></div>
            <FormControl className="formhistory-filter">
              <Autocomplete
                freeSolo
                disableClearable
                id="combo-box-autocomplete-manufacturer"
                className="combo-box-autocomplete-manufacturer"
                value={this.state.manufacturer}
                onChange={changeManufacturer}
                onInputChange={(e,newValue) => {
                    this.setState({manufacturer: newValue});
                  }
                }
                options={_.sortBy(manufacturers).filter(item => item.toLowerCase().includes(this.state.manufacturer.toLowerCase()))}
                getOptionLabel={(option) => option}
                renderInput={(params) => 
                  <TextField 
                    {...params} 
                    className="autocomplete-manufacturer" 
                    variant="outlined" 
                    fullWidth
                    // InputProps={{
                    //   ...params.InputProps,
                    //   type: 'search',
                    // }}
                  />
                }
              />
            </FormControl>
          </div>

          {/* <div className="terminalnew-form__group-item">
            <div className="terminalnew-form__item-title"><span>モデル</span></div>
            <TextField variant="outlined" className="terminalnew-form__item-value"
                value={this.state.system_model} 
                onChange={changeSystemModel}/>
          </div> */}
          <div className="terminalnew-form__group-item">
            <div className="terminalnew-form__item-title"><span>モデル</span></div>
            <FormControl className="formhistory-filter">
              <Autocomplete
                freeSolo
                disableClearable
                id="combo-box-autocomplete-manufacturer"
                className="combo-box-autocomplete-manufacturer"
                value={this.state.system_model}
                onChange={changeSystemModel}
                onInputChange={(e,newValue) => {
                    this.setState({system_model: newValue});
                  }
                }
                options={_.sortBy(models).filter(item => item.toLowerCase().includes(this.state.system_model.toLowerCase()))}
                getOptionLabel={(option) => option}
                renderInput={(params) => 
                  <TextField 
                    {...params} 
                    className="autocomplete-manufacturer" 
                    variant="outlined" 
                    fullWidth
                  />
                }
              />
            </FormControl>
          </div>

          <div className="terminalnew-form__group-item">
            <div className="terminalnew-form__item-title"><span>シリアル</span></div>
            <TextField variant="outlined" className="terminalnew-form__item-value"
                value={this.state.serial_number} 
                onChange={changeSerialNumber}/>
          </div>

          <div className="terminalnew-form__group-item">
            <div className="terminalnew-form__item-title"><span>使用開始日</span></div>
            {/* <DatePicker className="terminalnew-form__item-value"
              dateFormat="yyyy/MM/dd ～"
              selected={this.state.startDate}
              onChange={(date) => this.setState({startDate: date})}
            /> */}
            <div className="terminalnew-form__datepicker">
              <TextField　variant="outlined"
                id="startDate"
                type="date"
                value={this.state.startDate}
                onChange={changeStartDate}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
          </div>

          <div className="terminalnew-form__group-item">
            <div className="terminalnew-form__item-title"><span>OS</span></div>
            <NativeSelect className="terminaledit-form__item-value"
              id="demo-customized-select-native"
              value={this.state.os_id}
              onChange={changeTemminalOs}
              input={<BootstrapInput />}
            >
              <option aria-label="無し" value="" />
              {ositems.detailData && (ositems.detailData).map((ositem, index) => (
                <option value={ositem.i_num} key={index}>{ositem.name}</option>
              ))}
            </NativeSelect>
          </div>

          <div className="terminalnew-form__controls">
            <button className="terminalnew-btn" onClick={handleEdit}>登録</button>
          </div>
        </div>

      </div>
    );
  }
}

TerminalNew.propTypes = {
  getTerminals: PropTypes.func.isRequired,
};

export default TerminalNew;